import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowLeftShort } from "react-bootstrap-icons";
import "./BackButton.scss";

interface BackButtonProps {
  title: string;
}

export default function BackButton(props: BackButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="py-271-rem">
      <a
        href="/#"
        className="text-primary text-decoration-none font-weight-700 cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          navigate(-1);
        }}
      >
        <ArrowLeftShort className="back-button" />
        {t(props.title)}
      </a>
    </div>
  );
}
